export const HEADER_TITLE_CHANGED = "HEADER_TITLE_CHANGED"
export const HEADER_DESC_CHANGED = "HEADER_DESC_CHANGED"